// extracted by mini-css-extract-plugin
module.exports = {"comments":"Z_d7","comments__list":"Z_d8"};